import React from "react";
import { styled } from "@glitz/react";
import { theme, red, darkGrey, fontSize, fontWeight, spacing } from "../theme";

type PriceProps = {
  productPrice: {
    onSale: boolean;
    salePrice: string;
    regularPrice: string;
    price: string;
  };
  left?: boolean;
};

const Price: React.FC<PriceProps> = ({ productPrice, left }) => {
  const { onSale, salePrice, regularPrice, price } = productPrice;

  return (
    <PriceWrapper css={left && LeftStyles}>
      {onSale ? (
        <div>
          <SalePrice>{salePrice} :-</SalePrice>
          <RegularPrice>{regularPrice} :-</RegularPrice>
        </div>
      ) : (
        <div>{price} kr</div>
      )}
    </PriceWrapper>
  );
};

const PriceWrapper = styled.div({
  textAlign: "center",
  fontSize: fontSize.xl,
  fontWeight: fontWeight.bold,
});
const SalePrice = styled.span({
  color: red,
});
const RegularPrice = styled.span({
  textDecoration: "line-through",
  marginLeft: spacing.xs,
  color: darkGrey,
  fontSize: fontSize.l,
});

const LeftStyles = styled({
  textAlign: "left",
});

export default Price;
